import { arrayOf, bool, shape, string } from "prop-types";

import ErrorBoundary from "web/Layout/ErrorBoundary";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import SortFilter from "./sortFilter";

const Container = ({ className, options, classes, darkMode }) => {
  return isArrayHasItems(options) ? (
    <ErrorBoundary>
      <SortFilter
        className={className}
        options={options}
        classes={classes}
        darkMode={darkMode}
      />
    </ErrorBoundary>
  ) : null;
};

Container.propTypes = {
  className: string,
  darkMode: bool,
  options: arrayOf(shape({})),
  classes: shape({}),
};

Container.defaultProps = {
  className: "",
  darkMode: false,
  options: [],
  classes: {},
};

export default Container;
